import { V3PageHeaderController } from './page-header.controller';
import { Directive, input, output } from '@angular/core';
import {
  faCircleChevronLeft,
  faCircleChevronRight,
} from '@fortawesome/pro-light-svg-icons';

/**
 * Controller to be used for a section that contains a scsrollable ribbon
 */
@Directive()
export class V3PageHeaderWithScrollingController extends V3PageHeaderController {
  public showScrollButtons = input<boolean>(false);
  public scrollLeft = output();
  public scrollRight = output();

  protected faLeftIcon = faCircleChevronLeft;
  protected faRightIcon = faCircleChevronRight;
}
